import { render, staticRenderFns } from "./BookCategoryTemplate.vue?vue&type=template&id=5034f184&scoped=true&"
import script from "./BookCategoryTemplate.vue?vue&type=script&lang=js&"
export * from "./BookCategoryTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BookCategoryTemplate.vue?vue&type=style&index=0&id=5034f184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5034f184",
  null
  
)

export default component.exports